import store from './store';
import GoogleAnalytics from './GoogleAnalytics';

class Me {
	set(me) {
		this.me = me;
		store.dispatch_me(me);
		if (me && me.JustSignedUpWith) {
			// XXX the redirect possibly (and sporadically?)
			// cancles this GA event, but I feel like a puppet who
			// don't really have any clue what the GA-people want,
			// so WHATEVER! :-)
			GoogleAnalytics.signup(me.JustSignedUpWith);
			GoogleAnalytics.adwords_conversion("signup");
			window.location.href = "/welcome";
		}
	}

	get() {
		return this.me;
	}

}

export default new Me();



// WEBPACK FOOTER //
// ./src/Me.js